import { Redirect, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setMobileList } from 'redux/index';
import * as redux from 'redux/selectors';
import { useSelectorListState } from 'helpers/hooks';
import { getButtonArray } from '../utils/buttons';
import useManageHouseState from '../utils/useManageHouseState';
import StaticSelectorList from 'components/UtilityComponents/SelectorList/StaticSelectorList';
import {
	PageLayout,
	AddressForm,
	SectionHeader,
	StaticAddressForm,
	MobileHeader,
} from 'components';
import clsx from 'clsx';
import Alert from '@mui/material/Alert';
import styles from '../homes.module.css';
import DeleteHouseButton from './DeleteHouseButton';
import * as HouseComp from './';

export default function ManageHouse({
	basePath = '/homes',
	lifebookBasePath = '/lifebooks',
	resourceParentsBasePath = '/resource-parents',
	caseManager = false,
}) {
	const user = useSelector((state) => state.user.user);
	const isMd = useSelector(redux.getIsMd);
	const dispatch = useDispatch();
	const { houseId } = useParams();
	const houseHash = useSelector(redux.getLifebooksHousesHash);

	const { name, assignedParentList, assignedParentListLoaded } =
		useManageHouseState();
	const reduxHouseChildren = useSelector(
		redux.getLifebooksHouseChildren(houseId),
	);
	const pageTitle = houseId
		? `${houseHash[houseId]?.name || name.value} Household`
		: 'Add House';

	const childrenList = useSelector(redux.getLifebooksChildren);
	const childrenListState = useSelectorListState(
		childrenList,
		reduxHouseChildren,
	);

	const resourceParentList = useSelector(redux.getHomesRPList);

	const resourceParentListState = useSelectorListState(
		resourceParentList,
		assignedParentList,
		{
			loaded: assignedParentListLoaded,
		},
	);

	const disableDeleteButton = () => {
		//assignedParentList
		//reduxHouseChildren
		if (assignedParentList.length > 0 || reduxHouseChildren.length > 0) {
			return true;
		} else {
			return false;
		}
	};

	const getBody = () => {
		const reqBody = { name: name.value };
		return {
			reqBody,
			houseId,
			//childChanges: childrenListState.changes,
			//	resourceParentChanges: resourceParentListState.changes,
		};
	};

	const disabled =
		user.role === 'social-worker' && !user.privileged ? true : false;

	const buttonArray = disabled
		? null
		: getButtonArray(
				getBody,
				undefined,
				basePath,
				caseManager /*resetListChanges*/
		  );

	if (caseManager && houseId && !houseHash[houseId]) {
		return <Redirect to={`${basePath}/`} />;
	}

	return (
		<PageLayout
			title={pageTitle}
			buttonArray={buttonArray}
			align='left'
			header={
				caseManager && isMd ? (
					<MobileHeader onNavBack={() => dispatch(setMobileList(true))} />
				) : undefined
			}>
			{!houseId && !caseManager && !disabled ? (
				<Alert severity='info'>
					Save the household first. After it is created, add children and
					resource parents from their profile pages.
				</Alert>
			) : null}
			<HouseComp.HouseBasicInfo inputs={[name]} disable={disabled} />
			<SectionHeader>ADDRESS</SectionHeader>
			{!disabled && <AddressForm key={houseId} required={false} />}
			{disabled && <StaticAddressForm key={houseId} />}
			{/*	<HouseComp.HouseChildrenList
				disable={disabled}
				selectorListState={childrenListState}
			/>
			<HouseComp.HouseRPList
				disable={disabled}
				selectorListState={resourceParentListState}
			/>
			*/}
			{houseId && (
				<>
					<StaticSelectorList
						label='CHILDREN IN HOME'
						textFieldLabel='Children'
						{...childrenListState}
						linkTo={`${lifebookBasePath}/${
							caseManager ? 'profile' : 'manage'
						}/`}
					/>
					<StaticSelectorList
						label='RESOURCE PARENTS'
						textFieldLabel='Resource Parents'
						{...resourceParentListState}
						linkTo={`${resourceParentsBasePath}/manage/`}
					/>
					{!caseManager ? (
						<>
							<SectionHeader>Management Options</SectionHeader>
							<div
								className={clsx(
									styles.houseAdminItemWrapper,
									styles.houseAdminWarn,
								)}
								key={'Delete Home'}>
								<div>
									<div className={styles.houseAdminBoldLabel}>
										{'Delete Home'}
									</div>
									<div>
										{
											'This option will permanently delete this home from the Ella system.  In order to delete resource parents and children must be removed first'
										}
									</div>
								</div>
								<div className={styles.houseAdminButtonContainer}>
									<DeleteHouseButton
										houseId={houseId}
										houseSort={houseHash}
										disabled={disableDeleteButton()}
									/>
								</div>
							</div>
						</>
					) : null}
				</>
			)}
		</PageLayout>
	);
}
